export default function GridHeaderCell({ name }: { name: string }) {
  return <span className="header-cell">{name}</span>
}
